import { Redirect } from 'react-router-dom';
import { LetterDetailsEasySend } from 'assets/js/pages/engage/letters/LetterDetailsEasySend';
import { LetterDetailsManual } from 'assets/js/pages/engage/letters/LetterDetailsManual';
import { useCurrentLetter } from 'assets/js/pages/engage/letters/useCurrentLetter';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';

const LetterDetails = () => {
    const { accountId } = useCurrentAccount();
    const { data: letter } = useCurrentLetter();
    const isDraft = letter?.status === 'draft';
    const isEasySend = letter?.settings.send_to_print_and_mail_service === true;

    if (!letter) {
        return <Redirect to={`/accounts/${accountId}/engage/letters`} />;
    }

    if (isDraft) {
        return (
            <Redirect
                to={`/accounts/${accountId}/engage/letters/draft/${letter.id}/edit/details`}
            />
        );
    }

    if (isEasySend) {
        return <LetterDetailsEasySend />;
    }

    return <LetterDetailsManual />;
};

export { LetterDetails };
